export default __webpack_public_path__ + "static/score-bad-3e5fc92d3a1f2ee8e72006a330381053.svg";